import * as React from 'react';

import type {BadgeColor} from '../../badge/badge';
import type {Variant} from '../../control-bar/page-control-bar';
import {StackLegacy} from '../../layout/stack/stack-legacy';

import {PageTab} from './page-tab';

export type Tab = {
    Icon?: React.ComponentType<any> | string;
    label: string | null | undefined;
    isActive: boolean;
    id: string;
    onClick: () => any;
    count?: string;
    // If defined, a badge with the specified color will be shown next to the tab
    badgeColor?: BadgeColor;
};

type Props = {
    tabs: Tab[];
    currentView?: string;
    lessPadding?: boolean;
    variant?: Variant;
};

export function PageTabs(props: Props) {
    return (
        <StackLegacy isHorizontal={true} spacing={8} isFullHeight={true}>
            {props.tabs.map((tab) => {
                return (
                    <PageTab
                        key={tab.id}
                        {...tab}
                        lessPadding={props.lessPadding}
                        variant={props.variant}
                    />
                );
            })}
        </StackLegacy>
    );
}
